module.exports = __webpack_public_path__ + "static/img/spot2096.f2522b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spot2096.png
// module id = MyY3
// module chunks = 0